import React from 'react'

const LockClosedIcon = () => {
	return (
		<svg width={20} height={27} viewBox='0 0 20 27' fill='none' xmlns='http://www.w3.org/2000/svg'>
			<g clipPath='url(#clip0)' fill='currentColor'>
				<path d='M17.939 10.798H2.06C.923 10.798 0 11.742 0 12.906v11.652c0 1.165.923 2.109 2.061 2.109H17.94c1.138 0 2.061-.944 2.061-2.109V12.906c0-1.164-.923-2.108-2.061-2.108z' />
				<path d='M17.883 11.111V8.006c0-2.12-.823-4.152-2.288-5.651A7.726 7.726 0 0010.07.015c-2.073 0-4.06.841-5.525 2.34a8.085 8.085 0 00-2.289 5.65v3.075h3.427V8.006c0-1.194.463-2.34 1.289-3.183a4.352 4.352 0 013.112-1.319c1.167 0 2.286.475 3.112 1.319a4.554 4.554 0 011.289 3.183v3.105h3.398z' />
			</g>
			<defs>
				<clipPath id='clip0'>
					<path fill='currentColor' d='M0 0H20V26.6667H0z' />
				</clipPath>
			</defs>
		</svg>
	)
}

export default LockClosedIcon
